// src/Lexbuild/StickyChatBox.jsx
import React, { useState } from 'react';

export default function StickyChatBox({ onCreateFromConfig }) {
  const [input, setInput] = useState('');
  const [suggestion, setSuggestion] = useState(null);

  const fakeLLM = (prompt) => new Promise((res) =>
    setTimeout(() => res({ name: prompt.slice(0, 20), type: 'Custom', description: prompt }), 500)
  );

  const send = async () => {
    if (!input.trim()) return;
    const cfg = await fakeLLM(input.trim());
    setSuggestion(cfg);
    setInput('');
  };

  return (
    <>
      <div className="chat-bar">
        <div className="chat-bar-inner">
          <button className="chat-icon-btn">＋</button>
          <input
            className="chat-input-field"
            placeholder="Ask anything"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && send()}
          />
          <button className="chat-send-btn" onClick={send}>➤</button>
        </div>
      </div>
      {suggestion && (
        <div className="chat-suggestion" onClick={() => { onCreateFromConfig(suggestion); setSuggestion(null); }}>
          <div><strong>Name:</strong> {suggestion.name} | <strong>Type:</strong> {suggestion.type}</div>
          <button className="lb-primary-btn">➕ Create Agent</button>
        </div>
      )}
    </>
  );
}
